import React from 'react'
import { usePostRequest } from '../../../hooks/request'
import { BUILDING_CATEGORY_LIST } from '../../../urls'
import { useMessage } from '../../../hooks/message'
import BuildingCategoryForm from './BuildingCategoryForm'

export default function BuildingCategoryCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: BUILDING_CATEGORY_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>
            <BuildingCategoryForm
                loading={brandCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
